<div class="">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="register-form pt-3">
                    <form [formGroup]="vaultPayForm" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="margin-bottom: 5px;">
                                <div class="formSection">
                                    <div class="head">
                                        <strong>Vault Payment Information</strong>
                                    </div>
                                </div>
                                <div class="form-background">
                                    <div class="row d-f" style="padding: 10px;">
                                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label>Receiver Name <span class="formMandatoryInput">*</span></label>
                                                <ng-select formControlName="accountId"
                                                    placeholder="Select Receiver Name"
                                                    [ngClass]="{'is-invalid': Submitted && f['accountId'].errors}"
                                                    (change)="setReceiverData($event)"
                                                    [readonly]="vaultPayData?.currentRecord">
                                                    <ng-option value="">Select Receiver Name</ng-option>
                                                    <ng-option *ngFor="let receiver of receiverList"
                                                        [value]="receiver.accountId">
                                                        {{receiver?.name}}</ng-option>
                                                </ng-select>

                                                <div *ngIf=" Submitted && f['accountId'].errors"
                                                    style="color: red; font-size: 12px;">Receiver
                                                    name is reqiured.
                                                </div>
                                            </div>
                                        </div>
                                        <div class=" d-flex  col-sx-12 col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label for="fromDate">Payment Date <span
                                                        class="formMandatoryInput">*</span></label>
                                                <div class="d-flex align-items-center">
                                                    <p-calendar formControlName="transDate" dateFormat="dd/mm/yy"
                                                        [maxDate]="maxDate"
                                                        [ngClass]="{'is-invalid': Submitted && f['transDate'].errors}"
                                                        [showIcon]="true" inputId="buttondisplay" [showOnFocus]="false"
                                                        class="custom-calendar" />
                                                    <div *ngIf="Submitted && f['transDate'].errors"
                                                        style="color: red; font-size: 12px;">Date of payment is
                                                        reqiured.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class=" d-flex  col-sx-12 col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label>Amount <span class="formMandatoryInput">*</span></label>
                                                <input type="number" formControlName="amount"
                                                    class="form-control amount"
                                                    [ngClass]="{'is-invalid': Submitted && f['amount'].errors}" />
                                                <div *ngIf="Submitted && f['amount'].errors"
                                                    style="color: red; font-size: 12px;">
                                                    Amount is reqiured.</div>
                                            </div>
                                        </div>
                                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <label>Payment For <span class="formMandatoryInput">*</span></label>
                                                <ng-select formControlName="transRefType"
                                                    [(ngModel)]="currentTransRefType"
                                                    placeholder="Select Payment Reason"
                                                    [ngClass]="{'is-invalid': Submitted && f['transRefType'].errors}"
                                                    (change)="setReceiverData($event)"
                                                    [readonly]="vaultPayData?.currentRecord">
                                                    <ng-option value="">Select Receiver Name</ng-option>
                                                    <ng-option value="Sale">Sale</ng-option>
                                                    <ng-option value="Land Purchase">Land Purchase</ng-option>
                                                    <ng-option value="Material/Services Purchase">Material/Services
                                                        Purchase</ng-option>
                                                    <ng-option value="Loan">Personal Loan</ng-option>
                                                    <ng-option value="Business Loan">Business Loan</ng-option>
                                                    <ng-option value="Gift">Gift</ng-option>
                                                    <ng-option value="Employee Salary">Employee Salary</ng-option>
                                                    <ng-option value="Other">Other</ng-option>
                                                </ng-select>
                                                <div *ngIf=" Submitted && f['transRefType'].errors"
                                                    style="color: red; font-size: 12px;">Payment Reason reqiured.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">
                                                <div *ngIf="currentTransRefType.toLowerCase() =='sale'">
                                                    <label>Sale : Booking</label>
                                                    <p-inputSwitch [(ngModel)]="currentTransRefType" name=""
                                                        (onChange)="toggleTransRefType($event)"
                                                        class="pl-2 pr-2"></p-inputSwitch> Allotment
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-4">
                                            <div class="form-group">

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pad-wrap col-sm-12">
                            <div class="invoice-button">
                                <button type="submit" class="btn btn-success  cancel mr-2"
                                    (click)="onSubmit()">Submit</button>
                                <button type="button" class="btn btn-danger  cancel"
                                    (click)="closePaymentDialogue()">Cancel</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>